import api from "@/api/axios.js";

export async function getPromptHistory({entityType, entityId, limit = 20, offset = 0})
{
	const {data} = await api.get("/api/prompt-history", {
		params: {entityType, entityId, limit, offset}
	});
	return data;
}

export async function getPromptVersion(id)
{
	const {data} = await api.get(`/api/prompt-history/${id}`);
	return data;
}
